import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlatformService } from 'src/app/core/services/platform.service';

@Injectable()
export class FlagService {
    flags: BehaviorSubject<FlagService> = new BehaviorSubject(null);
    constructor(private platformService: PlatformService) {
        this.platformService.getFlags().subscribe((response) => {
            // this.flags = response;
            this.flags.next(response);
        });
    }
}